<style lang="scss">
  @use "../../../../../assets/css/global.scss" as *;
  @use "../../../../../assets/css/_colors.scss" as *;
  @use "../Components/TrainingHubMixins.scss" as *;
  .task-header {
    border: 0;
    background: 0;
    width: 100%;
    text-align: left;
    display: grid;
    grid-template-columns: auto 1fr auto auto;
    grid-template-areas:
      "icon title type expand"
      "icon duration duration duration";
    align-items: start;
    gap: 0rem 1rem;
    padding: 1rem 1rem calc(1rem - 10px) 1rem;
    cursor: pointer;

    .task-title {
      color: $soft-black;
      font-size: 1rem;
      margin: 0;
      display: flex;
      align-items: center;
      gap: 0.5rem;

      .video-preview-icon {
        color: $primary-color;
        font-size: 1.4rem;
        border: none;
        background: none;
        padding: 0;

        &:disabled {
          color: $text-gray;
        }
        @include training-hub-locked();
      }
    }

    &.isFirstOptional:not(.isNewSubgroup) {
      &::before {
        content: "";
        position: absolute;
        top: -5px;
        left: 0;
        right: 0;
        height: 1px;
        background-color: #e7e9f0;
      }
    }

    .optional-text {
      font-size: 0.9rem;
      color: $text-gray;
      margin-left: 0.5rem;
    }
    .header-type-category-wrapper {
      grid-area: type;
      display: flex;
      flex-wrap: wrap;
      gap: 0.5rem;

      .header-task-type,
      .header-category {
        font-size: 0.9rem;
        font-weight: 700;
        grid-area: type;
        padding: 2px 10px;
        border-radius: 1rem;

        @include training-hub-locked();
      }
      .header-task-type {
        color: $text-black;
        background: $light-gray;
      }

      .header-category {
        color: $primary-color;
        background: $light-blue;
      }
    }

    .expand-button {
      grid-area: expand;
      transition: transform 0.3s ease;
      background: none;
      border: none;

      &.expanded {
        transform: rotate(180deg);
      }

      i {
        font-size: 1.2rem;
        color: $soft-black;
      }
    }

    .task-duration {
      position: relative;
      top: -8px;
      font-size: 0.9rem;
      grid-area: duration;
      color: $text-gray;
    }
  }
</style>

<script>
  import { interactiveTasks, showVideoPreviewModal } from "../stores";

  import TrainingHubIcon from "../Components/TrainingHubIcon.svelte";

  export let task;

  $: locked = task.status === "locked";
  $: expanded = $interactiveTasks.selectedTaskId === task.taskId;
  $: optional = task.optional;
  $: isFirstOptional = task.isFirstOptional;
  $: isNewSubgroup = task.isNewSubgroup;

  const toggleTask = () => {
    const taskId =
      $interactiveTasks.selectedTaskId === task.taskId ? "" : task.taskId;
    interactiveTasks.setTask(taskId);
  };

  const taskHeaderKeydown = (e) => {
    if (!["Enter", " "].includes(e.key)) return;
    e.preventDefault();
    toggleTask();
  };

  let colorIndex = $interactiveTasks.tasks.findIndex(
    (t) => t.taskId === task.taskId
  );

  const previewClick = () => {
    interactiveTasks.setTask(task.taskId);
    $showVideoPreviewModal = true;
  };

  $: s = task.duration === 1 ? "" : "s";

  const licenseCategories = {
    ausConversations: "Conversations",
    ukConversations: "Conversations",
    usConversations: "Conversations",
    notetaker: "Notetaker",
    inboxAgent: "Inbox Agent",
    extension: "Sourcing",
    outreach: "Outreach",
    data: "Data",
    dataRefresh: "Data Refresh",
    projects: "Projects",
  };

  $: displayCategories = (() => {
    const licenses = task.licenses || [];

    const categories = new Set();

    licenses.forEach((license) => {
      if (licenseCategories[license]) {
        categories.add(licenseCategories[license]);
      } else {
        categories.add(license);
      }
    });

    if (categories.size === 0) {
      categories.add("General");
    }

    return Array.from(categories);
  })();
</script>

<div
  class="task-header"
  class:optional
  class:isFirstOptional
  class:isNewSubgroup
  on:click={() => toggleTask()}
  on:keydown={taskHeaderKeydown}
  role="button"
  aria-expanded={expanded}
  tabindex="0"
>
  <TrainingHubIcon icon={task.icon} {locked} {colorIndex} />
  <h4 class="task-title">
    {task.title}
    {#if task.videoPreview}
      <button
        class="fa-solid fa-circle-play video-preview-icon"
        disabled={locked}
        class:locked
        on:click|stopPropagation={previewClick}
        aria-label="Preview video"
      ></button>
    {/if}
    {#if optional}
      <span class="optional-text">(Optional)</span>
    {/if}
  </h4>
  <div class="header-type-category-wrapper">
    {#each displayCategories as category}
      <span class="header-category" class:locked>{category}</span>
    {/each}
    <span class="header-task-type" class:locked>{task.taskType}</span>
  </div>
  <button class="expand-button" class:expanded aria-label="Expand task">
    <i class="fa-sharp fa-regular fa-chevron-down"></i>
  </button>
  <span class="task-duration" class:locked>About {task.duration} min{s}</span>
</div>
